import style from './Icon.styl';
import * as images from './images';

export function Icon({ type, width, height }) {
  return (
    <img className={style.icon} src={images[type]} width={width} height={height} alt="" />
  );
}
